/* tslint:disable */
import {
  Project
} from '../index';

declare var Object: any;
export interface MilestoneInterface {
  "description"?: string;
  "dueDate"?: Date;
  "status"?: string;
  "projectId"?: number;
  "id"?: number;
  project?: Project;
}

export class Milestone implements MilestoneInterface {
  "description": string;
  "dueDate": Date;
  "status": string;
  "projectId": number;
  "id": number;
  project: Project;
  constructor(data?: MilestoneInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Milestone`.
   */
  public static getModelName() {
    return "Milestone";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Milestone for dynamic purposes.
  **/
  public static factory(data: MilestoneInterface): Milestone{
    return new Milestone(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Milestone',
      plural: 'Milestones',
      path: 'Milestones',
      properties: {
        "description": {
          name: 'description',
          type: 'string'
        },
        "dueDate": {
          name: 'dueDate',
          type: 'Date'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "projectId": {
          name: 'projectId',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        project: {
          name: 'project',
          type: 'Project',
          model: 'Project'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/Milestone.ts